export default (type, colors) => {
  const styles = {
    default: {
      'list__def--simple': {
        customCSS: `
          .beta a,
          .list__def--simple dt {
            color: ${colors.primary};
            font-weight: 800;
          }
        `
      },
    },
    type1: {
      'c-share-modal': {
        fontSize: 16
      },
      'list__def--simple': {
        customCSS: `
          .beta a,
          .beta a:hover,
          .list__def--simple dt {
            color: ${colors.primary};
            font-weight: 800;
          }
        `
      },
      'list__def--simple__div': {
        marginBottom: '16px',
      },
      'list__def--simple__tabs': {
        marginTop: '40px',
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cShare.js